import { Tag } from "@carbon/react";
import { useTranslation } from "react-i18next";

/**
 * A "2ª ronda" badge shown when an order has been re-opened for a second (or later) round.
 * Renders nothing for the first round. For a joint group, pass the max round across its lines.
 */
const SecondRoundTag = ({ round }: { round?: number }) => {
  const { t } = useTranslation();
  if (!round || round < 2) return null;
  return (
    <Tag type="purple" size="sm">
      {t("tenders.data.roundBadge", { round })}
    </Tag>
  );
};

export default SecondRoundTag;
